import { render, staticRenderFns } from "./videoAiEventQuerry.vue?vue&type=template&id=23860b36&scoped=true"
import script from "./videoAiEventQuerry.vue?vue&type=script&lang=js"
export * from "./videoAiEventQuerry.vue?vue&type=script&lang=js"
import style0 from "./videoAiEventQuerry.vue?vue&type=style&index=0&id=23860b36&prod&lang=scss&scoped=true"
import style1 from "./videoAiEventQuerry.vue?vue&type=style&index=1&id=23860b36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23860b36",
  null
  
)

export default component.exports